import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    //case types.COMPANY_LISTING_FETCH_DEDUCTION_SETUP_LIST :
    case types.COMPANY_DEDUCTION_MAIN_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
